declare global {
  interface Window {
    gConfig: Record<string, string> | undefined;
  }
}

const config = new Proxy(
  {},
  {
    get(_target, prop) {
      if (typeof prop === "symbol") {
        return undefined;
      }
      return window.gConfig?.[prop] ?? import.meta.env[prop];
    },
  }
) as Record<string, string | undefined>;

export const ADDR_DIVISION = config.VUE_APP_ADDR_DIVISION?.toUpperCase?.() || undefined;

export default config;
